module.exports = __webpack_public_path__ + "img/magnum-hyper.e3e549c9.svg";